import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
import i18n from "../../public/lang/index";
import { Message } from "element-ui";
import moment from "moment";
// 獲取日期周幾
export const getWeek = function (date) {
  var now = new Date(date);
  var day = now.getDay();
  var weeks = new Array(
    i18n.t("message.Booking.weeks.Sunday"),
    i18n.t("message.Booking.weeks.Monday"),
    i18n.t("message.Booking.weeks.Tuesday"),
    i18n.t("message.Booking.weeks.Wednesday"),
    i18n.t("message.Booking.weeks.Thursday"),
    i18n.t("message.Booking.weeks.Friday"),
    i18n.t("message.Booking.weeks.Saturday")
  );
  var week = weeks[day];
  return week;
}
export default {
  // 一戶通登入
  splicingAccountLogin: function (serviceType) {
    const pathUrl = process.env.VUE_APP_BASE_RESOURCE_PATH;
    const lang = i18n.t('message.lang') || 'zh-hant';
    return `${pathUrl}/protected/login-page/account?serviceType=${serviceType}&client=${serviceType}&Language=${lang}`;
  },
  splicingEntityLogin: function (serviceType) {
    const pathUrl = process.env.VUE_APP_BASE_RESOURCE_PATH;
    const lang = i18n.t('message.lang') || 'zh-hant';
    return `${pathUrl}/protected/login-page/entity-account?serviceType=${serviceType}&client=${serviceType}&Language=${lang}`;
  },
  // 驗證文件格式
  uploadExtCheck: function (fileName, extensions) {
    var FileExt = fileName.replace(/.+\./, "");
    if (extensions.indexOf(FileExt.toLowerCase()) === -1) {
      Message({
        type: "warning",
        message: i18n.t("message.upload_extensions_tips", [extensions])
      });
      return false;
    } else {
      return true;
    }
  },
  // 驗證文件大小
  fsLimit: function (size, max) {
    var isLt = size / 1024 / 1024 < max ? true : false;
    if (!isLt) {
      Message({
        type: "error",
        message: `${i18n.t("message.upload_maxSize_tips")}${max}MB`,
      });
      return false;
    } else {
      return true;
    }
  },
  // 千分位
  thousand: function (num) {
    if (num) {
      return num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    } else {
      return '-';
    }
  },
};


export const checkServerStatus = async (serviceType) => {
  const { status, online, maintenance } = await ServiceTypeConfigAPI.getDetails(serviceType);
  if (status !== 'A') {
    throw i18n.t("message.ErrorMessage.SERVICE_FAILURE");
  } else if (!online) {
    throw i18n.t("message.offline");
  } else if (maintenance) {
    throw i18n.t("message.maintenance_tips1");
  }
}

export const downloadFile = function (res) {
  // 下載文件
  let blobData = new Blob([res.data]);
  let fileName = res.headers['content-disposition'].split(';')[1].split('=')[1];
  fileName = fileName ? decodeURI(fileName) : '.txt';
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blobData, fileName);
  } else {
    let elink = document.createElement('a');
    elink.download = fileName;
    elink.style.display = 'none';
    elink.href = URL.createObjectURL(blobData);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
  }
};

export const isAfterYears = (date, year) => {
  const birthDate = moment(date);
  const now = moment();
  return now.isAfter(birthDate.clone().add(year, "years"));
}